<template>
  <div>
    <el-input
      v-model="identifyNo"
      readonly
      :size="size"
      :placeholder="placeholder"
    >
      <el-button
        :disabled="disabled"
        slot="append"
        icon="el-icon-finished"
        @click="() => (dialogVisible = true)"
      ></el-button>
    </el-input>

    <IdentifyDialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      :identifyJson="identifyJson"
      @change="identifyChange"
    />
  </div>
</template>
<script>
import IdentifyDialog from './dialog.vue'
export default {
  components: { IdentifyDialog },
  props: {
    identifyNo: { type: String, default: '' },
    identifyJson: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    size: { type: String, default: 'medium' },
  },
  data() {
    return {
      dialogVisible: false,
      initStatus: true,
    }
  },
  methods: {
    identifyChange(val) {
      let identifyNo = ''
      if (val) {
        const data = JSON.parse(val)
        identifyNo = data
          .map((i) => i.identifyCodeTypeText + ':' + i.identifyNo)
          .join()
      }
      this.$emit('update:identifyNo', identifyNo)
      this.$emit('update:identifyJson', val)
    },
  },
}
</script>
